import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgLjAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.24976 2.24963C-0.000244141 4.49884 -0.000244141 8.11914 -0.000244141 15.3602V16.6398C-0.000244141 23.8809 -0.000244141 27.5012 2.24976 29.7504C4.49829 32 8.11841 32 15.3591 32H16.6404C23.8811 32 27.5012 32 29.7498 29.7504C31.9998 27.5012 31.9998 23.8809 31.9998 16.6398V15.3602C31.9998 8.11914 31.9998 4.49884 29.7498 2.24963C27.5012 0 23.8811 0 16.6404 0H15.3591C8.11841 0 4.49829 0 2.24976 2.24963ZM18.2822 21.1351C18.8341 19.8595 19.8569 18.8308 21.1307 18.2714H21.1332L21.8797 21.879L18.2822 21.1351ZM10.7958 5.89001C8.59937 6.85046 6.83771 8.61719 5.88989 10.8186L7.97255 12.8946C8.92289 10.6956 10.6829 8.92638 12.8852 7.96593L20.5814 15.6495C18.3867 16.61 16.6233 18.3767 15.6755 20.5782L7.97255 12.8996C7.46958 14.0538 7.17049 15.3092 7.17049 16.6496C7.17049 21.8773 11.4091 26.11 16.641 26.11C21.8696 26.11 26.1099 21.8748 26.1099 16.6496C26.1099 11.4244 21.8696 7.18915 16.641 7.18915C15.304 7.18915 14.0335 7.46717 12.881 7.96509L10.7958 5.89001Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLjAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
